var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Portfolio as PortfolioModel } from '@/models/Portfolio';
import _ from 'lodash';
import UploadFileDialog from '@/views/Users/Student/Progress/UploadFileDialog';
import ErrorHandler from '@/support/ErrorHandler';
import { Year } from '@/models/Year';
import ActionsMenu from '@/components/ActionsMenu/ActionsMenu.vue';
let ProgressCitoResults = class ProgressCitoResults extends Vue {
    constructor() {
        super(...arguments);
        this.portfolioClone = null;
        this.files = [];
        this.deleteResultList = [];
        this.isEditingCitoResults = false;
        this.isUpdatingCitoResults = false;
        this.isUploadingCitoResult = false;
        this.resultFiles = [];
        this.categorizedFiles = [];
        this.years = [];
    }
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.portfolioClone = _.cloneDeep(this.portfolio);
        await this.fetchYears();
        this.filterFiles();
    }
    filterFiles() {
        if (!this.portfolioClone || !this.portfolioClone.files) {
            return;
        }
        this.resultFiles = this.portfolioClone.files.filter((file) => {
            return file.collection === 'cito-results';
        });
        this.categorizeResultFiles();
    }
    categorizeResultFiles() {
        if (!this.resultFiles || this.resultFiles.length === 0) {
            return;
        }
        const yearMap = {};
        this.resultFiles.forEach((file) => {
            const year = this.getYear(file);
            if (year) {
                if (!yearMap[year.id]) {
                    yearMap[year.id] = {
                        label: year.name || '-',
                        files: [],
                        startsAt: year.starts_at || '',
                    };
                }
                yearMap[year.id].files.push(file);
            }
        });
        this.categorizedFiles = Object.values(yearMap)
            .sort((a, b) => new Date(b.startsAt).getTime() - new Date(a.startsAt).getTime())
            .map(({ startsAt, ...rest }) => rest); // Remove startsAt after sorting
    }
    getYear(file) {
        if (!file || !file.created_at) {
            return null;
        }
        const foundYear = this.years.find((year) => {
            if (!year.starts_at || !year.ends_at || !file.created_at) {
                return false;
            }
            const startsAt = year.starts_at;
            const endsAt = year.ends_at;
            const createdAt = new Date(file.created_at);
            return createdAt >= new Date(startsAt) && createdAt <= new Date(endsAt);
        });
        return foundYear ? foundYear : null;
    }
    fileUploaded() {
        this.$emit('portfolioUpdated');
    }
    resetResults() {
        this.deleteResultList = [];
        this.resultFiles = _.cloneDeep(this.portfolio).files;
        this.filterFiles();
        this.isEditingCitoResults = false;
    }
    deleteResult(deletedFile) {
        this.resultFiles = this.resultFiles.filter((file) => {
            return file.id !== deletedFile.id;
        });
        this.deleteResultList.push(deletedFile);
    }
    updateResults() {
        this.deleteResultList.forEach((file) => {
            new PortfolioModel()
                .deleteFileFromPortfolio(this.portfolio.id, file.id)
                .then(() => {
                this.$emit('portfolioUpdated');
                this.deleteResultList = [];
            })
                .catch((error) => {
                ErrorHandler.network(error);
            });
        });
    }
    async fetchYears() {
        try {
            this.years = await new Year().all();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    get actionsMenuActions() {
        const actions = [
            {
                icon: 'add',
                label: this.$tc('progress.button.add', 0, { item: this.$tc('progress.result.title', 1) }),
                visible: this.user.hasRole(['teacher', 'root']),
                action: () => {
                    this.isUploadingCitoResult = true;
                },
                disabled: false,
            },
            {
                icon: 'edit',
                label: this.$tc('progress.button.edit', 0, { item: this.$tc('progress.result.title', 1) }),
                visible: this.user.hasRole(['teacher', 'root']) && this.categorizedFiles.length > 0,
                action: () => {
                    this.isEditingCitoResults = true;
                },
                disabled: false,
            },
        ];
        return actions;
    }
    get user() {
        return this.$store.state.Auth;
    }
    get dialogOptions() {
        return {
            title: this.$t('progress.dialog.title').toString(),
            text: this.$t('progress.dialog.subtitle', { item: this.$tc('progress.result.title', 2) }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                    action: async () => {
                        await this.updateResults();
                        this.isEditingCitoResults = false;
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.isUpdatingCitoResults = false;
                    },
                },
            },
        };
    }
};
__decorate([
    Prop({ default: {} }),
    __metadata("design:type", typeof (_a = typeof PortfolioModel !== "undefined" && PortfolioModel) === "function" ? _a : Object)
], ProgressCitoResults.prototype, "portfolio", void 0);
ProgressCitoResults = __decorate([
    Component({
        components: {
            'upload-file-dialog': UploadFileDialog,
            ActionsMenu,
        },
    })
], ProgressCitoResults);
export default ProgressCitoResults;
